import React from 'react';
import PaginationBase from '../../../common/base/PaginationBase';
import { message } from 'antd';
import moment from 'moment';

import { PAGINATION, FILTER } from '../../../common/types/paginationType';
import { FACTURA, ORDEN_COMPRA, OTROS } from '../../../common/types/tipoComprobanteType';
import { SOLES, DOLARES_AMERICANOS } from '../../../common/types/monedaType';

import dialog from '../../../common/utility/dialog';
import global from '../../../common/utility/global';
import auth from '../../../common/utility/auth';

import requerimientoService from '../../../service/logistica/requerimientoService';
import monedaService from '../../../service/administracion/monedaService';
import listaPrecioService from '../../../service/administracion/listaPrecioService';
import tipoCambioDiarioService from '../../../service/administracion/tipoCambioDiarioService';
import establecimientoService from '../../../service/administracion/establecimientoService';
import almacenService from '../../../service/administracion/almacenService';
import vendedorService from '../../../service/administracion/vendedorService';
import proveedorService from '../../../service/administracion/proveedorService';
import tipoComprobanteService from '../../../service/administracion/tipoComprobanteService';
import productoService from '../../../service/administracion/productoService';
import proyectoService from '../../../service/administracion/proyectoService';
import ordenCompraService from '../../../service/logistica/ordenCompraService';
import padronReducidoService from '../../../service/integracion/padronReducidoService';
import empleadoService from '../../../service/administracion/empleadoService';
import configuracionService from '../../../service/seguridad/usuarioConfiguracionService';
import { lst_tipo_afectacion } from "../../../common/types/tipoAfectacion";

import Header from '../../../components/Header';
import Filters from './Filters';
import FormModal from './FormModal';
import ResultList from './ResultList';
import BuscarProductoModal from './BuscarProductoModal';
import ImportarRequerimientoModal from './ImportarRequerimientoModal';
import FormModalVer from '../OrdenCompra/FormModalVer';
import RenombrarProductoModal from './RenombrarProductoModal';
import ImprimirModal from './ImprimirModal';

import IngresoObservacionModal from '../OrdenCompraAprobacion/IngresoObservacionModal'


import { APROBADO } from '../../../common/types/ordenCompraEstadoType';
import { LOGISTICA_REQUERIMIENTO } from '../../../common/types/referenciaOrigenType';
import { LOGISTICA } from '../../../common/types/moduloType';

import { APROBAR_OC, VER_SERIES_LOG } from '../../../common/types/configuracionType';
import DetalleIngreso from './DetalleIngreso';

var referenciaCount = 1;
var formModalPorImportar = null;
var products = [];

export default class Index extends PaginationBase {

    constructor(props) {
        super(props);
        this.props.onSetBreadcrumb();
        this.state = {
            loadingSource: true,
            loadingPrint: true,
            monedas: [],
            tiposCambioDiario: [],
            listasPrecio: [],
            establecimientos: [],
            almacenes: [],
            vendedores: [],
            proveedores: [],
            direcciones: [],
            tiposComprobante: [],
            productos: [],
            detracciones: [],
            proyectos: [],
            requerimientos: [],
            estado: [],
            empleado: [],
            configuraciones: [],
            filter: {
                //nombre: '',
                fechaInicioStr: global.fetchCurrentDateStr(true),
                fechaFinStr: global.fetchCurrentDateStr(),
                documento: '',
                serie: '',
                idEstadoOrdenCompra: 0,
                idProveedor: 0,
                idProyecto: 0,
                tipoReporte: 1,

                ...FILTER
            },
            pagination: PAGINATION,
            visible: false,
            productoVisible: false,
            observacionVisible: false,

            importarRequerimientoVisible: false,
            visibleVer: false,
            renombrarProductoVisible: false,
            formValues: this.fetchEmptyFormValues(),
            productoModal: {
                nombre: '',
                dataSource: [],
                selectedRowKeys: []
            },
            importarRequerimientoModal: {
                nombre: '',
                dataSource: [],
                dataSourceDetalle: [],
                selectedRowKeys: []
            },
            renombrarProductoModal: {
                nombre: '',
                idProducto: 0,
                index: 0
            },
            imprimirFormValues: {
                file: undefined,
                idOrdenCompra: 0
            }
        }
    }

    handleKeyUpInput = (e) => {
        e.preventDefault();
        if (e.keyCode === 13) {
            const filter = { ...this.state.filter, ...FILTER };
            this._handlePagination(filter);
        }
    };

    handleClearFilters = () => {
        var filter = {
            fechaInicioStr: global.fetchCurrentDateStr(true),
            fechaFinStr: global.fetchCurrentDateStr(),
            documento: '',
            serie: this.state.filter.serie,
            idEstadoOrdenCompra: 0,
            idProveedor: 0,
            idProyecto: 0,
            tipoReporte: 1,

            ...FILTER
        };
        this.setState({ filter });
        this._handlePagination(filter);
    };

    handleChange = (property, value) => {
        const filter = { ...this.state.filter, [property]: value };
        this.setState({ filter });
        if (property = 'tipoReporte') {
            this._handlePagination(filter)
        }
    };


    handleNew = async () => {

        var idSoles = SOLES;
        var formValues = this.fetchEmptyFormValues();
        formValues.monedas = this.state.monedas;
        formValues.tipoCambio = this.fetchTipoCambio(DOLARES_AMERICANOS);
        formValues.listasPrecio = this.state.listasPrecio.filter(m => m.id === idSoles);
        formValues.establecimientos = this.state.establecimientos;
        formValues.idListaPrecio = formValues.listasPrecio.length === 0 ? 0 : formValues.listasPrecio[0].id;
        formValues.tiposComprobante = this.state.tiposComprobante;
        formValues.proyectos = this.state.proyectos;
        formValues.proveedores = this.state.proveedores;
        formValues.empleado = this.state.empleado;
        formValues.tipoAfectacion = lst_tipo_afectacion;


        const datosInicialesFilter = {
            idUsuario: auth.user().id,
            idTipoComprobante: ORDEN_COMPRA.ID
        }
        const datosIniciales = await ordenCompraService.datosIniciales(datosInicialesFilter);

        if (datosIniciales !== undefined) {
            formValues.idAlmacen = datosIniciales.idAlmacen;
            formValues.idEstablecimiento = datosIniciales.idEstablecimiento;
            formValues.serie = datosIniciales.serie;

        }

        if (formValues.idEstablecimiento > 0) {
            const almacenes = await await almacenService.listarPorIdEstablecimiento(formValues.idEstablecimiento);
            formValues.almacenes = almacenes ? almacenes : [];
        }

        var productos = await productoService.listar();
        var productos_filter = productos.filter(m => m.idTipoProducto === 1);

        if (formValues.serie == "" || formValues.serie == null) {
            setTimeout(() => {
                dialog.error("Tiene que registrar serie correlativo para poder registrar el documento");

            }, 100);

        } else {
            this.setState({
                visible: true,
                formValues,
                productos: productos_filter ? productos_filter : [],
                productoModal: {
                    ...this.state.productoModal,
                    selectedRowKeys: []
                },
                requerimientos: [],
                importarRequerimientoModal: {
                    ...this.state.importarRequerimientoModal,
                    selectedRowKeys: []
                }
            });
        }

    }

    fetchTipoCambio = (idMoneda, tiposCambioDiario) => {
        const filter = (tiposCambioDiario ? tiposCambioDiario : this.state.tiposCambioDiario).filter(m => m.idMoneda === idMoneda);
        if (filter.length > 0)
            return parseFloat(filter[0].compraSunat).toFixed(3);
        else
            return '0.000';
    }

    handleChangeForm = async (property, value, form) => {

        if (property === "idProveedor") {
            const direcciones = await establecimientoService.listarPorIdEntidad(value);
            this.setState({
                formValues: {
                    ...this.state.formValues,
                    direcciones: direcciones ? direcciones : []
                }
            }, () => {
                form.setFieldsValue({
                    idEstablecimientoProveedor: { key: direcciones.length > 0 ? direcciones[0].id : undefined }
                });
            });
        }

        if (property === "idEstablecimiento") {
            debugger
            this.setState({ formValues: { ...this.state.formValues, almacenLoading: true } });
            const almacenes = await almacenService.listarPorIdEstablecimiento(value);
            this.setState({
                formValues: {
                    ...this.state.formValues,
                    almacenLoading: false,
                    almacenes: almacenes ? almacenes : []
                }
            });
        }


        if (property === "fechaStr") {
            debugger
            console.log('cambio 1')
            var arrayD1 = value.split('/');
            //const dias_vencimiento = this.CalcularDiasVencimiento(value, this.state.formValues.fechaVencimientoStr);
            const tiposCambioDiario = await tipoCambioDiarioService.listarPorFecha(value);

            this.setState({
                formValues: {
                    ...this.state.formValues,
                    tipoCambio: this.fetchTipoCambio(DOLARES_AMERICANOS, tiposCambioDiario),
                    //diasVencimiento: dias_vencimiento,
                    fechaStr: value,
                    //minFechaStr: arrayD1[2] + "/" + arrayD1[1] + "/" + arrayD1[0]
                }
            });
        }

        if (property === "fechaVencimientoStr") {
            const dias_vencimiento = this.CalcularDiasVencimiento(this.state.formValues.fechaStr, value);

            this.setState({
                formValues: {
                    ...this.state.formValues,
                    diasVencimiento: dias_vencimiento,
                    fechaVencimientoStr: value
                }
            });
        }

        if (property === "diasVencimiento") {
            var arrayD1 = this.state.formValues.fechaStr.split('/');
            var date1 = new Date(arrayD1[2] + "/" + arrayD1[1] + "/" + arrayD1[0]);
            var fechaVencimiento = date1.setDate(date1.getDate() + parseInt(value));

            let day = date1.getDate()
            let month = date1.getMonth() + 1
            let year = date1.getFullYear()

            var fechaVencStr = '';

            if (month < 10) {
                fechaVencStr = `${day}/0${month}/${year}`;
            } else {
                fechaVencStr = `${day}/${month}/${year}`;
            }

            this.setState({
                formValues: {
                    ...this.state.formValues,
                    fechaVencimientoStr: fechaVencStr
                }
            });
        }

        if (property === "idMoneda") {
            const listasPrecio = this.state.listasPrecio.filter(m => m.idMoneda === value);
            this.setState({
                formValues: {
                    ...this.state.formValues,
                    listasPrecio: listasPrecio ? listasPrecio : []
                }
            });
        }

        if (property === "idListaPrecio") {
            const listasPrecio = this.state.listasPrecio.filter(m => m.idMoneda === value);
            this.setState({
                formValues: {
                    ...this.state.formValues,
                    listasPrecio: listasPrecio ? listasPrecio : []
                }
            });
        }



        if (property === "idPendiente") {
            //1 contado
            //1 pendiente de pago SI (2) NO
            var listaComprobanteMetodoPago = this.state.formValues.listaComprobanteMetodoPago;
            if (listaComprobanteMetodoPago.length > 0 && value == 1) { // PENDIENTE

                dialog.confirm("Al cambiar el estado se eliminaran el Método de Pago \n ¿Esta seguro de realizar la acción?", () => {

                    this.setState({
                        formValues: {
                            ...this.state.formValues,
                            listaComprobanteMetodoPago: [],
                            idPendiente: value,

                        }
                    });
                }, () => {

                    this.setState({
                        formValues: {
                            ...this.state.formValues,
                            idPendiente: 2,

                        }
                    });

                }

                );

            } else {
                this.setState({
                    formValues: {
                        ...this.state.formValues,
                        idPendiente: value,

                    }
                });
            }

            this.setState({ isPendienteSi: value == 1 ? false : true });


        }

        if (property === "idFormaPago") {

            if (value == 2) { //CREDITO isPendienteSi

                const fecha = moment(form.getFieldValue("fechaStr"), "DD/MM/YYYY");
                const diasVencimiento = 1;
                form.setFieldsValue({
                    fechaVencimientoStr: fecha.add("days", diasVencimiento)
                });

                this.setState({ isPendiente: true });
                this.setState({ isPendienteSi: true });

                this.setState({
                    formValues: {
                        ...this.state.formValues,
                        idFormaPago: value,
                        idPendiente: 1, //SI
                    },
                });

                form.setFieldsValue({
                    idFormaPago: value,
                    idPendiente: { key: 1 },
                });

            } else {
                // CONTADO
                const fecha = moment(form.getFieldValue("fechaStr"), "DD/MM/YYYY");
                const diasVencimiento = -0;
                form.setFieldsValue({
                    fechaVencimientoStr: fecha.add("days", diasVencimiento),
                });
                this.setState({ isPendiente: false });
                this.setState({ isPendienteSi: false });

                this.setState({
                    formValues: {
                        ...this.state.formValues,
                        idFormaPago: value,
                        idPendiente: 2
                    },
                });

                form.setFieldsValue({
                    idFormaPago: value,
                    idPendiente: { key: 2 },
                });


            }
        }

    }

    CalcularDiasVencimiento = (fecha_1, fecha_2) => {
        var arrayD1 = fecha_1.split('/');
        var arrayD2 = fecha_2.split('/');

        var date1 = new Date(arrayD1[2] + "/" + arrayD1[1] + "/" + arrayD1[0]);
        var dateFV = new Date(arrayD2[2] + "/" + arrayD2[1] + "/" + arrayD2[0]);

        var Difference_In_Time = dateFV.getTime() - date1.getTime();
        var Difference_In_Days = Difference_In_Time / (1000 * 3600 * 24);

        return Difference_In_Days;
    }

    handleChangeTab = (key) => {
        this.setState({
            formValues: {
                ...this.state.formValues,
                activeKey: key
            }
        });
    };

    handleAgregarDetalle = () => {
        if (this.state.formValues.activeKey === "1")
            this.handleBuscarProducto();

        if (this.state.formValues.activeKey === "2")
            this.handleAddReferencia();
    };

    handleAddReferencia = () => {
        var listaComprobanteReferencia = this.state.formValues.listaComprobanteReferencia;

        listaComprobanteReferencia.push({
            identifier: global.fetchUniqueCode(),
            idReferencia: 0,
            idReferenciaOrigen: 0,
            idTipoComprobante: 0,
            series: "",
            documentos: "",
            flagInterno: false
        });

        referenciaCount = referenciaCount + 1;

        this.setState({
            formValues: {
                ...this.state.formValues,
                listaComprobanteReferencia: listaComprobanteReferencia
            }
        });
    };

    handleRemoverReferencia = (id) => {
        var listaComprobanteReferencia = this.state.formValues.listaComprobanteReferencia.filter(m => m.identifier !== id.identifier);
        this.setState({
            formValues: {
                ...this.state.formValues,
                listaComprobanteReferencia: listaComprobanteReferencia
            },
        });
    }

    handleBuscarProducto = () => {

        this.setState({
            productoVisible: true,
            productoModal: {
                ...this.state.productoModal,
                dataSource: this.state.productos
            }
        });
    }

    handleImportarRequerimiento = async () => {
        var filterSearchReq = {
            idEstadoRequerimiento: APROBADO,
            filtro: '',
            idTipoOperacion: 1
        };
        debugger
        var requerimientos = await requerimientoService.listarPorEstado(filterSearchReq);
        this.setState({
            importarRequerimientoVisible: true,
            importarRequerimientoModal: {
                ...this.state.importarRequerimientoModal,
                dataSource: requerimientos ? requerimientos : [],
                dataSourceDetalle: []
            }
        })
    }

    handleChangeProductoModal = (value) => {
        if (value != null && value != undefined && value != '') {
            const dataSource = this.state.productos.filter(item => {
                return (item.codigoReferencia + ' - ' + item.nombre)
                    .toUpperCase()
                    .match(value.toUpperCase());
            });

            this.setState({
                productoModal: {
                    ...this.state.productoModal,
                    dataSource: dataSource
                }
            });
        } else {
            this.setState({
                productoModal: {
                    ...this.state.productoModal,
                    dataSource: this.state.productos
                }
            });
        }
    };

    handleChangeSelectedRowKey = (selected, rows) => {
        var listaComprobanteDetalle = this.state.formValues.listaComprobanteDetalle;
        debugger
        rows.forEach(item => {
            var filter = this.state.formValues.listaComprobanteDetalle.filter(m => { return m.idProducto === item.id; });
            if (filter.length === 0) {

                listaComprobanteDetalle.push({
                    identifier: global.fetchUniqueCode(),
                    idProducto: item.id,
                    nombre: item.nombre,
                    cantidad: 0,
                    codigo: item.codigoReferencia,
                    nombreUnidadMedida: item.nombreUnidadMedida,
                    precioUnitario: 0,
                    precioUnitarioSinIGV: 0,
                    total: 0,
                    flagAfecto: item.flagIGVAfecto,
                    flagGratuito: false,
                    flagExonerado: false,
                    subTotal: 0,
                    igv: 0,
                    precioNuevo: 0,
                    idImpuesto: item.idImpuesto
                })
            }
        });

        listaComprobanteDetalle = listaComprobanteDetalle.filter(m => selected.filter(f => f === m.idProducto).length);

        this.setState({
            formValues: {
                ...this.state.formValues,
                listaComprobanteDetalle: listaComprobanteDetalle
            },
            productoModal: {
                ...this.state.productoModal,
                selectedRowKeys: selected
            }
        });
    };

    handleRemoverProducto = (identifier) => {
        var listaComprobanteDetalle = this.state.formValues.listaComprobanteDetalle.filter(m => m.identifier !== identifier);
        var selectedRowKeys = this.state.productoModal.selectedRowKeys.filter(m => m !== identifier);

        this.setState({
            formValues: {
                ...this.state.formValues,
                listaComprobanteDetalle: listaComprobanteDetalle
            },
            productoModal: {
                ...this.state.productoModal,
                selectedRowKeys: selectedRowKeys
            }
        });
    };

    handleOnChangeProveedor = async (value) => {
        console.log(value);
        debugger
        var numDoc = value.label.split('-')[value.label.split('-').length - 1];
        console.log(value.label);

        this.setState({
            formValues: {
                ...this.state.formValues,
                documentoProveedor: numDoc
            }
        });

        const direccionesEstablecimientos = await establecimientoService.listarPorIdEntidad(value.key);
        if (direccionesEstablecimientos === undefined) {
            this.setState({
                formValues: {
                    ...this.state.formValues,
                    //proveedorLoading: false,
                    //proveedores: [],
                    direcciones: [],
                }
            });
        } else {
            this.setState({
                formValues: {
                    ...this.state.formValues,
                    //proveedorLoading: false,
                    //proveedores: resultFilter//.proveedores,
                    direcciones: direccionesEstablecimientos,
                    documentoProveedor: numDoc
                    //idProveedor: response.proveedores.length > 0 ? response.proveedores[0].id : 0,
                    //idEstablecimientoProveedor: response.direcciones.length > 0 ? response.direcciones[0].id : 0
                }
            });
        }
    }


    handleBuscarProveedor = async (value, form) => {
        this.setState({
            formValues: { ...this.state.formValues, proveedorLoading: true },
        });

        //const response = await padronReducidoService.logistica_proveedor(value);
        var numberDocument = form.getFieldValue("documentoProveedor");
        if (numberDocument == "" || numberDocument == "null" || numberDocument == "undefined") {
            dialog.warning(<ul>Ingrese documento valido</ul>);

            return;
        }

        var response = numberDocument.length == 8 ? await padronReducidoService.obtenerProveedorDniApi(value) :
            await padronReducidoService.obtenerProveedorRucApi(value);
        if (response.status === 400) {
            dialog.warning(<ul>{response.data.messages.map(item => (<li>{item}</li>))}</ul>);
            this.setState({ formValues: { ...this.state.formValues, proveedorLoading: false } });

            return;
        }

        if (response.status === 200) {

            this.setState(
                {
                    formValues: {
                        ...this.state.formValues,
                        proveedorLoading: false,
                        direcciones: response.data.direcciones,
                    },
                },
                () => {
                    form.setFieldsValue({
                        proveedores: response.data.proveedores,
                        idProveedor:
                            response.data.proveedores.length > 0
                                ? { key: response.data.proveedores[0].id }
                                : undefined,
                        idEstablecimientoProveedor:
                            response.data.direcciones.length > 0
                                ? { key: response.data.direcciones[0].id }
                                : undefined,
                        direccionProveedor:
                            response.data.direcciones.length > 0
                                ? response.data.direcciones[0].direccion
                                : ""
                    });
                }
            );
        } else {
            this.setState(
                {
                    formValues: {
                        ...this.state.formValues,
                        clienteLoading: false,
                        direcciones: [],
                    },
                },
                () => {
                    form.setFieldsValue({
                        clientes: [],
                        idCliente: undefined,
                        idEstablecimientoCliente: undefined,
                    });
                }
            );
        }
    };



    handleChangeNameProduct = (row, index) => {
        console.log(row);
        this.setState({
            renombrarProductoVisible: true,
            renombrarProductoModal: {
                ...this.state.renombrarProductoModal,
                nombre: row.nombre,
                idProducto: row.idProducto,
                index: index
            }
        })
    }

    handleOkChangeNameProduct = (value, form) => {
        var listaComprobanteDetalle_aux = this.state.formValues.listaComprobanteDetalle.filter(m => m.idProducto !== value.idProducto);

        var currentRow = this.state.formValues.listaComprobanteDetalle.filter(m => m.idProducto === value.idProducto)[0];
        currentRow.nombre = value.nombre;
        //console.log(currentRow)
        var position = this.state.renombrarProductoModal.index;

        listaComprobanteDetalle_aux.splice(position, 0, currentRow);


        var empty_renombrarProductoModal = {
            nombre: '',
            idProducto: 0,
            index: 0
        };

        form.setFieldsValue(empty_renombrarProductoModal);
        form.resetFields();

        this.setState({
            renombrarProductoVisible: false,
            renombrarProductoModal: {
                ...this.state.renombrarProductoModal,
                nombre: '',
                idProducto: 0,
                index: 0
            },
            formValues: {
                ...this.state.formValues,
                listaComprobanteDetalle: listaComprobanteDetalle_aux
            }
        });
    }

    handleSave = async (values, form) => {
        dialog.confirm("¿Esta seguro de realizar la acción?", async () => {
            debugger

            if (values.ordenCompraDetalles !== undefined) {
                for (var i = 0; i < values.ordenCompraDetalles.length; i++) {
                    var item = this.state.formValues.listaComprobanteDetalle.filter(m => m.idProducto === values.ordenCompraDetalles[i].idProducto)[0];
                    values.ordenCompraDetalles[i].nombre = item.nombre;
                }
            }

            var response;
            if (values.id === 0 || values.id === undefined)
                response = await ordenCompraService.registrar(values);
            else
                response = await ordenCompraService.modificar(values);

            if (response.status === 200) {
                var empty = this.fetchEmptyFormValuesDos();
                this.setState({ visible: false, formValues: empty });
                form.setFieldsValue(empty);
                form.resetFields();

                if (values.id === 0)
                    message.success('Registrado correctamente.');
                else
                    message.success('Modificado correctamente.');

                this._handlePagination(this.state.filter);
                return;
            }

            if (response.status === 400) {
                dialog.warning(<ul>{response.data.messages.map(item => (<li key={global.fetchUniqueCode()}>{item}</li>))}</ul>);
                return;
            }

            dialog.error('Ocurrió un error inesperado, por favor vuelva a intentarlo más tarde.');
        });
    };

    handleEdit = async (values) => {
        const response = await ordenCompraService.obtenerPorId(values.id);
        if (response !== undefined) {
            debugger
            var formValues = this.fetchEditFormValues(response);
            formValues.monedas = this.state.monedas;
            formValues.tipoCambio = this.fetchTipoCambio(DOLARES_AMERICANOS);
            formValues.listasPrecio = this.state.listasPrecio.filter(m => m.id === SOLES);
            formValues.establecimientos = this.state.establecimientos;
            formValues.idListaPrecio = formValues.listasPrecio.length === 0 ? 0 : formValues.listasPrecio[0].id;
            formValues.tiposComprobante = this.state.tiposComprobante;
            formValues.proyectos = this.state.proyectos;
            formValues.almacenes = await almacenService.listarPorIdEstablecimiento(formValues.idEstablecimiento);
            formValues.empleado = this.state.empleado;
            formValues.tipoAfectacion = lst_tipo_afectacion;


            const filterSearchProveedor = {
                numeroDocumento: formValues.documentoProveedor,
                idTipoComprobante: OTROS.ID
            }
            const responseProveedores = await proveedorService.obtenerTodos(filterSearchProveedor);
            const direccionesEstablecimientos = await establecimientoService.listarPorIdEntidad(response.ordenCompra.idEntidadProveedor);

            formValues.proveedores = responseProveedores;
            formValues.direcciones = direccionesEstablecimientos;

            var filterSearchReq = {
                idEstadoRequerimiento: APROBADO,
                filtro: ''
            };
            //var productos = await productoService.listarPorIdListaPrecio(formValues.idListaPrecio);
            // var requerimientos = await requerimientoService.listarPorEstado(filterSearchReq);
            //formValues.requerimientos = requerimientos;


            const products = [];
            for (var i = 0; i < response.ordenCompraDetalles.length; i++) {
                var item = response.ordenCompraDetalles[i];
                var oneProd = {
                    identifier: global.fetchUniqueCode(),
                    idProducto: item.idProducto,
                    nombre: item.nombre,
                    cantidad: item.cantidad,
                    codigo: item.codigoReferencia,
                    nombreUnidadMedida: item.nombreUnidadMedida,
                    precioUnitario: item.precioUnitario,
                    precioUnitarioSinIGV: item.precioUnitarioSinIGV,
                    total: item.total,
                    flagAfecto: item.flagAfecto,
                    flagExonerado: item.flagExonerado,
                    flagGratuito: item.flagGratuito,
                    subTotal: item.subTotal,
                    igv: item.igv,
                    precioNuevo: item.total,
                    idImpuesto: item.idImpuesto

                }

                formValues.listaComprobanteDetalle.push(oneProd);

                products.push(item.idProducto);
            }

            for (var i = 0; i < response.ordenCompraReferencias.length; i++) {
                referenciaCount = i + 1;
                var item = response.ordenCompraReferencias[i];
                var oneRef = {
                    identifier: global.fetchUniqueCode(),
                    idReferencia: item.id,
                    idReferenciaOrigen: item.idReferenciaOrigen,
                    idTipoComprobante: item.idTipoComprobante,
                    serie: item.serie,
                    documento: item.documento,
                    flagInterno: true
                }
                formValues.listaComprobanteReferencia.push(oneRef);
            }

            referenciaCount = response.ordenCompraReferencias.length + 1;

            var productos = await productoService.listar();
            var productos_filter = productos.filter(m => m.idTipoProducto === 1);

            this.setState({
                visible: true,
                formValues,
                productos: productos_filter ? productos_filter : [],
                productoModal: {
                    ...this.state.productoModal,
                    selectedRowKeys: products// []
                },
                requerimientos: [],
                importarRequerimientoModal: {
                    ...this.state.importarRequerimientoModal,
                    selectedRowKeys: []
                }
            });

        }
    }

    handleVer = async (values) => {
        const response = await ordenCompraService.obtenerPorId(values.id);
        if (response !== undefined) {
            var formValues = this.fetchEditFormValues(response);

            for (var i = 0; i < response.ordenCompraDetalles.length; i++) {
                var item = response.ordenCompraDetalles[i];
                var oneProd = {
                    identifier: global.fetchUniqueCode(),
                    idProducto: item.idProducto,
                    nombre: item.nombre,
                    cantidad: item.cantidad,
                    codigo: item.codigoReferencia,
                    nombreUnidadMedida: item.nombreUnidadMedida,
                    precioUnitario: item.precioUnitario,
                    total: item.total,
                    flagAfecto: item.flagAfecto,
                    flagExonerado: item.flagExonerado,
                    flagGratuito: item.flagGratuito,
                    precioUnitarioSinIGV: 0,
                    subTotal: item.subTotal,
                    igv: item.igv,
                    idImpuesto: item.idImpuesto

                }

                formValues.listaComprobanteDetalle.push(oneProd);

            }

            for (var i = 0; i < response.ordenCompraReferencias.length; i++) {
                referenciaCount = i + 1;
                var item = response.ordenCompraReferencias[i];
                var oneRef = {
                    identifier: referenciaCount,
                    idReferencia: item.id,
                    idReferenciaOrigen: item.idReferenciaOrigen,
                    idTipoComprobante: item.idTipoComprobante,
                    serie: item.serie,
                    documento: item.documento,
                    flagInterno: true,
                    nombreTipoComprobante: item.nombreTipoComprobante
                }
                formValues.listaComprobanteReferencia.push(oneRef);
            }

            this.setState({
                visibleVer: true,
                formValues
            });
        }
    }

    fetchMinCurrentDateStr(firstDayOfTheMonth) {
        var date = new Date();
        var yyyy = date.getFullYear();
        var mm = String(date.getMonth() + 1).padStart(2, '0');
        var dd = firstDayOfTheMonth === true ? '01' : String(date.getDate()).padStart(2, '0');
        return yyyy + '/' + mm + '/' + dd;
    };

    fetchEmptyFormValues = () => {
        return {
            id: 0,
            idProveedor: 0, //..........................................................OK
            idEstablecimientoProveedor: 0, //..........................................................OK
            idAlmacen: 0, //..........................................................OK
            idMoneda: SOLES, //..........................................................OK
            idListaPrecio: 0, //..........................................................OK
            idEstablecimiento: 0, //..........................................................OK
            idProyecto: 0,
            serie: "OC01",
            documento: "", //............................................... OK
            fechaStr: global.fetchCurrentDateStr(), //......................................... OK
            fechaVencimientoStr: global.fetchCurrentDateStr(), //......................................... OK
            minFechaStr: this.fetchMinCurrentDateStr(),
            diasVencimiento: 0, //..........................................................OK
            tipoCambio: 0, //..........................................................OK
            observacion: "", //..........................................................OK
            listaComprobanteDetalle: [],
            listaComprobanteReferencia: [],
            /*********************/
            //sumaTotalDetalle: 0,
            //sumaImporteDescuento: 0,
            idEmpleado: 0,
            idTipo: 1,
            sumaSubTotal: 0,
            sumaIgv: 0,
            sumaTotal: 0,
            almacenLoading: false,
            proveedorLoading: false,
            activeKey: "1",
            documentoProveedor: "",
            condicion: "",
            plazo: "",
            monedas: [],
            empleado: [],
            listasPrecio: [],
            establecimientos: [],
            almacenes: [],
            proveedores: [],
            direcciones: [],
            tiposComprobante: [],
            proyectos: [],
            proveedores: [],
            idRequerimiento: 0
        }
    };

    fetchEmptyFormValuesDos = () => {
        var d = new Date();
        var _year = d.getFullYear();
        return {
            id: 0,
            idProveedor: 0, //..........................................................OK
            idEstablecimientoProveedor: 0, //..........................................................OK
            idAlmacen: 0, //..........................................................OK
            idMoneda: SOLES, //..........................................................OK
            idListaPrecio: 0, //..........................................................OK
            idEstablecimiento: 0, //..........................................................OK
            idProyecto: 0,
            serie: 'OC01', //............................................... OK
            documento: "", //............................................... OK
            //fechaStr: global.fetchCurrentDateStr(), //......................................... OK
            //fechaVencimientoStr: global.fetchCurrentDateStr(), //......................................... OK
            diasVencimiento: 0, //..........................................................OK
            tipoCambio: 0, //..........................................................OK
            observacion: "", //..........................................................OK
            listaComprobanteDetalle: [],
            idEmpleado: 0,
            listaComprobanteReferencia: [],
            empleado: [],
            /*********************/
            //sumaTotalDetalle: 0,
            //sumaImporteDescuento: 0,
            sumaSubTotal: 0,
            sumaIgv: 0,
            sumaTotal: 0,
            almacenLoading: false,
            proveedorLoading: false,
            activeKey: "1",
            documentoProveedor: "",
            condicion: "",
            plazo: "",
            monedas: [],
            listasPrecio: [],
            establecimientos: [],
            almacenes: [],
            proveedores: [],
            direcciones: [],
            tiposComprobante: [],
            proyectos: [],
            proveedores: [],
            idRequerimiento: 0
        }
    };

    fetchEditFormValues = (value) => {
        console.log(value);
        debugger
        return {
            id: value.ordenCompra.id,
            idProveedor: value.ordenCompra.idProveedor, //..........................................................OK
            idEstablecimientoProveedor: value.ordenCompra.idEstablecimientoProveedor, //..........................................................OK
            idAlmacen: value.ordenCompra.idAlmacen, //..........................................................OK
            idMoneda: value.ordenCompra.idMoneda, //..........................................................OK
            idListaPrecio: 0, //..........................................................OK
            idEstablecimiento: value.ordenCompra.idEstablecimiento,
            idProyecto: value.ordenCompra.idProyecto,
            serie: value.ordenCompra.serie, //............................................... OK
            documento: value.ordenCompra.documento, //............................................... OK
            documentoProveedor: value.ordenCompra.documentoProveedor,

            condicion: value.ordenCompra.condicion,
            plazo: value.ordenCompra.plazo,
            fechaStr: value.ordenCompra.fechaStr, //global.fetchCurrentDateStr(), //......................................... OK
            fechaVencimientoStr: value.ordenCompra.fechaVencimientoStr, //......................................... OK
            diasVencimiento: value.ordenCompra.diasVencimiento, //..........................................................OK
            tipoCambio: value.ordenCompra.tipoCambio, //..........................................................OK
            observacion: value.ordenCompra.observacion, //..........................................................OK
            listaComprobanteDetalle: [],
            listaComprobanteReferencia: [],
            /*********************/
            //sumaTotalDetalle: 0,
            //sumaImporteDescuento: 0,
            idEmpleado: value.ordenCompra.idEmpleado,
            sumaSubTotal: value.ordenCompra.subTotal,
            sumaIgv: value.ordenCompra.igv,
            sumaTotal: value.ordenCompra.total,
            //almacenLoading: false,
            proveedorLoading: false,
            activeKey: "1",
            monedas: [],
            //tiposCambioDiario: [],
            listasPrecio: [],
            establecimientos: [],
            almacenes: [],
            empleado: [],
            proveedores: [],
            direcciones: [],
            tiposComprobante: [],
            //detracciones: []
            proyectos: [],
            proveedores: [],
            idRequerimiento: 0,
            idTipo: value.ordenCompra.idTipo,
            /*Para la opcion ver*/
            nombreMoneda: value.ordenCompra.nombreMoneda,
            nombreProyecto: value.ordenCompra.nombreProyecto,
            nombreAlmacen: value.ordenCompra.nombreAlmacen,
            proveedor: value.ordenCompra.proveedor,
            direccionEstablecimiento: value.ordenCompra.direccionEstablecimiento,
            nombreEstablecimientoSucursal: value.ordenCompra.nombreEstablecimientoSucursal
        }
    }

    fetchImportarRequerimientoFormValues = (value) => {
        //console.log(value);
        var d = new Date();
        var _year = d.getFullYear();
        return {
            id: value.ordenCompra.id,
            //idTipoComprobante: FACTURA.ID,
            idProveedor: value.ordenCompra.idProveedor, //..........................................................OK
            idEstablecimientoProveedor: value.ordenCompra.idEstablecimientoProveedor, //..........................................................OK
            //idVendedor: 0, //..........................................................OK
            idAlmacen: value.ordenCompra.idAlmacen, //..........................................................OK
            idMoneda: value.ordenCompra.idMoneda, //..........................................................OK
            idListaPrecio: 0, //..........................................................OK
            idProyecto: value.ordenCompra.idProyecto,
            //idComprobanteEstado: 0,
            //idEstablecimiento: 0, //..........................................................OK
            //idDetraccion: 0, //..........................................................OK
            //idUsuarioRegistro: 0,
            serie: 'OC01', //............................................... OK
            documento: value.ordenCompra.documento, //............................................... OK
            documentoProveedor: value.ordenCompra.documentoProveedor,
            fechaStr: value.ordenCompra.fechaStr, //global.fetchCurrentDateStr(), //......................................... OK
            fechaVencimientoStr: value.ordenCompra.fechaVencimientoStr, //......................................... OK
            diasVencimiento: value.ordenCompra.diasVencimiento, //..........................................................OK
            //numeroPlaca: "", //..........................................................OK
            tipoCambio: value.ordenCompra.tipoCambio, //..........................................................OK
            observacion: value.ordenCompra.observacion, //..........................................................OK
            //flagExportacion: false, //..........................................................OK
            //flagPercepcion: false, //..........................................................OK
            //flagDetraccion: false, //..........................................................OK
            //flagAnticipo: true,
            //flagGrifo: true,
            listaComprobanteDetalle: [],
            listaComprobanteReferencia: [],
            /*********************/
            //sumaTotalDetalle: 0,
            //sumaImporteDescuento: 0,
            sumaSubTotal: value.ordenCompra.subTotal,
            sumaIgv: value.ordenCompra.igv,
            sumaTotal: value.ordenCompra.total,
            //porcentajeDetraccion: 0,
            //importeDetraccion: 0,
            //totalDetraccion: 0,
            //porcentajePercepcion: 0,
            //importePercepcion: 0,
            //totalPercepcion: 0,
            //totalDetailDisabled: auth.user().parametros.filter(m => m.abreviatura === VENTA_MODIFICAR_TOTAL_PRODUCTO)[0].valor === "1" ? false : true,
            //flagEmpresaGrifo: auth.user().parametros.filter(m => m.abreviatura === EMPRESA_GRIFO)[0].valor === "1" ? true : false,
            //almacenLoading: false,
            proveedorLoading: false,
            activeKey: "1",
            documentoProveedor: value.ordenCompra.documentoProveedor,
            monedas: [],
            //tiposCambioDiario: [],
            listasPrecio: [],
            establecimientos: [],
            almacenes: [],
            //vendedores: [],
            proveedores: [],
            direcciones: [],
            tiposComprobante: [],
            //detracciones: []
            proyectos: []
        }
    }

    handleSelectedRowRequerimientoPorImportar = async (selected, rows) => {

        var arraySelect = [];
        const idReqImport = selected[selected.length - 1];
        const response = await requerimientoService.obtenerPorId(idReqImport);

        arraySelect.push(idReqImport);

        if (response !== undefined) {

            var formValues = this.fetchEmptyFormValues(response);
            formValues.monedas = this.state.monedas;
            formValues.tipoCambio = this.fetchTipoCambio(DOLARES_AMERICANOS);
            formValues.listasPrecio = this.state.listasPrecio.filter(m => m.id === SOLES);
            formValues.establecimientos = this.state.establecimientos;
            formValues.idListaPrecio = formValues.listasPrecio.length === 0 ? 0 : formValues.listasPrecio[0].id;
            formValues.tiposComprobante = this.state.tiposComprobante;
            formValues.proyectos = this.state.proyectos;
            formValues.idRequerimiento = idReqImport;
            formValues.idProyecto = response.requerimiento.idProyecto;

            if (this.state.formValues.id !== undefined && this.state.formValues.id > 0) {
                formValues.id = this.state.formValues.id;
                formValues.serie = this.state.formValues.serie;
                formValues.documento = this.state.formValues.documento;
            }

            products = [];
            for (var i = 0; i < response.requerimientoDetalles.length; i++) {
                var item = response.requerimientoDetalles[i];
                var oneProd = {
                    identifier: global.fetchUniqueCode(),
                    id: item.id,
                    idProducto: item.idProducto,
                    nombre: item.nombre,
                    cantidad: item.cantidad,
                    codigo: item.codigoReferencia,
                    nombreUnidadMedida: item.nombreUnidadMedida,
                    idImpuesto: 1,
                    precioUnitario: 0,
                    total: 0,
                    flagAfecto: item.flagIGVAfecto,
                    precioUnitarioSinIGV: 0,
                    subTotal: 0,
                    igv: 0,
                    precioNuevo: 0
                }
                formValues.listaComprobanteDetalle.push(oneProd);

                products.push(item.idProducto);
            }

            var itemRefReq = {
                identifier: global.fetchUniqueCode(),
                idReferencia: response.requerimiento.id,
                idReferenciaOrigen: LOGISTICA_REQUERIMIENTO,
                idTipoComprobante: 88,
                serie: response.requerimiento.serie,
                documento: response.requerimiento.documento,
                flagInterno: true
            }
            formValues.listaComprobanteReferencia.push(itemRefReq);
            // referenciaCount = 2;

            // for (var i = 0; i < response.requerimientoReferencias.length; i++) {

            //     var item = response.requerimientoReferencias[i];
            //     var oneRef = {
            //         identifier: referenciaCount,
            //         idReferencia: item.id,
            //         idReferenciaOrigen: item.idReferenciaOrigen,
            //         idTipoComprobante: item.idTipoComprobante,
            //         serie: item.serie,
            //         documento: item.documento,
            //         flagInterno: true
            //     }
            //     referenciaCount = referenciaCount + 1;
            //     formValues.listaComprobanteReferencia.push(oneRef);
            // }

            formModalPorImportar = formValues;

            this.setState({
                importarRequerimientoVisible: true,
                importarRequerimientoModal: {
                    ...this.state.importarRequerimientoModal,
                    dataSourceDetalle: formValues.listaComprobanteDetalle,
                    selectedRowKeys: arraySelect//selected
                },
                formValues: {
                    ...this.state.formValues,
                    formValues
                },
            })
        }
    }

    handleOkImportarRequerimiento = (values, form) => {
        if (formModalPorImportar === undefined || formModalPorImportar === null) {
            message.warning('Debe seleccionar un requerimiento.');
            return;
        }

        var idSoles = SOLES;
        formModalPorImportar.monedas = this.state.monedas;
        formModalPorImportar.tipoCambio = this.fetchTipoCambio(DOLARES_AMERICANOS);
        formModalPorImportar.listasPrecio = this.state.listasPrecio.filter(m => m.id === idSoles);
        formModalPorImportar.establecimientos = this.state.establecimientos;
        formModalPorImportar.idListaPrecio = formModalPorImportar.listasPrecio.length === 0 ? 0 : formModalPorImportar.listasPrecio[0].id;
        formModalPorImportar.tiposComprobante = this.state.tiposComprobante;
        formModalPorImportar.proyectos = this.state.proyectos;
        formModalPorImportar.activeKey = "2";

        this.setState({
            importarRequerimientoVisible: false,
            formValues: {
                ...this.state.formValues,
                idProyecto: formModalPorImportar.idProyecto,
                listaComprobanteDetalle: formModalPorImportar.listaComprobanteDetalle,
                listaComprobanteReferencia: formModalPorImportar.listaComprobanteReferencia,
                sumaSubTotal: 0,
                sumaIgv: 0,
                sumaTotal: 0,
                idRequerimiento: formModalPorImportar.idRequerimiento,
                activeKey: "2",
            },
            productoModal: {
                ...this.state.productoModal,
                selectedRowKeys: products
            }
        })

    }

    handleAnular = async (values) => {

        var flagAnular = this.state.configuraciones.filter((m) => m.abreviatura === APROBAR_OC).length >= 1 ? true : false;

        if (!flagAnular) {
            message.warning('Usted no puede anular Orden de Compra.');
            return false;
        }

        dialog.confirm("¿Esta seguro de realizar la acción?", async () => {
            debugger
            var data = {
                idOrdenCompra: values.id,
                codOrdenCompraEstado: 'AN',
                observacionRechazado: ''
            };
            var response = await ordenCompraService.actualizarEstado(data);

            if (response.status === 200) {
                var empty = this.fetchEmptyFormValues();
                this.setState({ visible: false, formValues: empty });

                message.success('Registrado anulado correctamente.');

                this._handlePagination(this.state.filter);
                return;
            }

            if (response.status === 400) {
                dialog.warning(<ul>{response.data.messages.map(item => (<li key={global.fetchUniqueCode()}>{item}</li>))}</ul>);
                return;
            }

            dialog.error('Ocurrió un error inesperado, por favor vuelva a intentarlo más tarde.');
        });
    }

    handleChangeRequerimientoModal = (value) => {
        const dataSource = this.state.requerimientos.filter(item => {
            return (item.serie + ' - ' + item.documento)
                .toUpperCase()
                .match(value.toUpperCase());
        });

        this.setState({
            importarRequerimientoModal: {
                ...this.state.importarRequerimientoModal,
                dataSource: dataSource
            }
        });
    };

    handleExportExcel = async () => {
        this.setState({ loadingPdf: true });
        var response = await ordenCompraService.excel(this.state.filter);
        this.setState({ loadingPdf: false });
        if (response !== undefined)
            global.dowloadFile(response.data, "Reporte de Orden de Compra.xlsx");
    }

    handleExportPdf = async () => {
        this.setState({ loadingPdf: true });
        var response = await ordenCompraService.pdf(this.state.filter);
        this.setState({ loadingPdf: false });
        if (response !== undefined)
            global.dowloadFile(response.data, "Reporte de Orden de Compra.pdf");
    }

    handleDetalleExportExcel = async () => {
        this.setState({ loadingExcel: true });

        var response = await ordenCompraService.excelDetallado(this.state.filter);
        this.setState({ loadingExcel: false });

        if (response !== undefined)
            global.dowloadFile(response.data, "Reporte de Orden de Compra Detallado.xlsx");
    }


    handlePrint = async () => {
        this.setState({ loadingPrint: true });
        var response = await ordenCompraService.pdf(this.state.filter);
        this.setState({ loadingPrint: false });
        if (response !== undefined) {
            var file = window.URL.createObjectURL(response.data);
            var win = window.open(file, '_blank');
            win.focus();
        }
    }

    handleImprimir = async (item) => {
        this.setState({ loadingPrint: true });

        var file = undefined;
        var response = await ordenCompraService.pdfA4({ id: item.id });
        file = window.URL.createObjectURL(response.data);
        this.setState({ loadingPrint: false });
        this.setState({
            imprimirVisible: true,
            imprimirFormValues: {
                ...this.state.imprimirFormValues,
                file,
                idOrdenCompra: item.id
            }
        });
    };

    //#region




    handleRechazar = async (values) => {

        var flagAnular = this.state.configuraciones.filter((m) => m.abreviatura === APROBAR_OC).length >= 1 ? true : false;

        if (!flagAnular) {
            message.warning('Usted no puede rechazar Orden de Compra.');
            return false;
        }
        dialog.confirm(`¿Desea rechazar la Orden de Compra ${values.serie}-${values.documento}?`, async () => {
            debugger
            const emptyForm = this.fetchEmptyFormValues();
            emptyForm.iD = values.id;
            this.setState({
                observacionVisible: true,
                formValues: emptyForm,
                ingresoObservacionModal: {
                    ...this.state.ingresoObservacionModal
                }
            });
        });
    }

    handleCompletarRechazo = async (values, form) => {
        debugger
        var data = {
            idOrdenCompra: values.id,
            codOrdenCompraEstado: 'RE',
            observacionRechazado: values.observacionRechazo
        };
        console.log(data);
        var response = await ordenCompraService.actualizarEstado(data);

        if (response.status === 200) {
            var empty = this.fetchEmptyFormValues();
            this.setState({ observacionVisible: false, formValues: empty });
            form.setFieldsValue(empty);
            form.resetFields();

            message.success('Registrado rechazado correctamente.');

            this._handlePagination(this.state.filter);
            return;
        }

        if (response.status === 400) {
            dialog.warning(<ul>{response.data.messages.map(item => (<li key={global.fetchUniqueCode()}>{item}</li>))}</ul>);
            return;
        }

        dialog.error('Ocurrió un error inesperado, por favor vuelva a intentarlo más tarde.');

    }


    handleAprobar = async (values) => {

        var flagAnular = this.state.configuraciones.filter((m) => m.abreviatura === APROBAR_OC).length >= 1 ? true : false;

        if (!flagAnular) {
            message.warning('Usted no puede aprobar Orden de Compra.');
            return false;
        }
        dialog.confirm(`¿Desea aprobar la Orden de Compra ${values.serie}-${values.documento}?`, async () => {

            var data = {
                idOrdenCompra: values.id,
                codOrdenCompraEstado: 'AP'
            };
            var response = await ordenCompraService.actualizarEstado(data);

            if (response.status === 200) {
                var empty = this.fetchEmptyFormValues();
                this.setState({ visible: false, formValues: empty });
                //form.setFieldsValue(empty);
                //form.resetFields();

                message.success('Registrado aprobado correctamente.');

                this._handlePagination(this.state.filter);
                return;
            }

            if (response.status === 400) {
                dialog.warning(<ul>{response.data.messages.map(item => (<li key={global.fetchUniqueCode()}>{item}</li>))}</ul>);
                return;
            }

            dialog.error('Ocurrió un error inesperado, por favor vuelva a intentarlo más tarde.');
        });
    }


    //#endregion

    async componentDidMount() {
        //debugger
        var idUsuario = auth.user().id;
        const datosIniciales = await ordenCompraService.datosIniciales({ idUsuario: idUsuario, idTipoComprobante: ORDEN_COMPRA.ID, });

        const configuraciones = await configuracionService.obtenerPorModulo({ idUsuario: idUsuario, idModulo: LOGISTICA });
        var flagSerie = configuraciones.filter((m) => m.abreviatura === VER_SERIES_LOG).length >= 1 ? true : false;

        const serie = [undefined, null].includes(datosIniciales?.serie) ? flagSerie ? '' : '-' : datosIniciales.serie;


        this.setState({ filter: { ...this.state.filter, serie } });

        this._initPagination({ ...this.state.filter, serie }, ordenCompraService.paginacion);

        const monedas = await monedaService.listar();
        const tiposCambioDiario = await tipoCambioDiarioService.listarPorFecha(global.fetchCurrentDateStr());
        const listasPrecio = await listaPrecioService.listar();
        const establecimientos = await establecimientoService.principales();
        const vendedores = await vendedorService.listar();
        const tiposComprobante = await tipoComprobanteService.listar();
        const proyectos = await proyectoService.listar();
        const empleado = await empleadoService.listar();

        const filter = {
            numeroDocumento: null,
            idTipoComprobante: OTROS.ID// FACTURA.ID
        }

        const proveedores = await proveedorService.obtenerTodos(filter);

        this.setState({
            loadingSource: false,
            loadingPrint: false,
            tiposCambioDiario: tiposCambioDiario ? tiposCambioDiario : [],
            monedas: monedas ? monedas : [],
            listasPrecio: listasPrecio ? listasPrecio : [],
            establecimientos: establecimientos ? establecimientos : [],
            vendedores: vendedores ? vendedores : [],
            tiposComprobante: tiposComprobante ? tiposComprobante : [],
            proyectos: proyectos ? proyectos : [],
            proveedores: proveedores ? proveedores : [],
            empleado: empleado ? empleado : [],
            configuraciones: configuraciones ? configuraciones : [],
        });
    }



    render() {
        //debugger
        return (
            <div>
                <Header
                    title={this.state.filter.tipoReporte == 1 ? "Orden de Compra" : "Orden de Compra Detallado"}
                    onNew={this.handleNew}
                    loadingNew={this.state.loadingSource}
                    onSearch={() => this._handlePagination(this.state.filter)}
                    onClearFilters={this.handleClearFilters}
                />
                <Filters
                    filter={this.state.filter}
                    estado={this.state.estado}
                    entidades={this.state.proveedores}
                    onKeyUpSearch={this.handleKeyUpInput}
                    onChange={this.handleChange}
                    proyectos={this.state.proyectos}
                    configuraciones={this.state.configuraciones}

                />


                {this.state.filter.tipoReporte == 1 ?
                    <ResultList
                        pagination={this.state.pagination}
                        loadingPrint={this.state.loadingPrint}
                        loadingEdit={this.state.loadingSource}
                        onExportExcel={this.handleExportExcel}
                        onExportPdf={this.handleExportPdf}
                        onPrint={this.handlePrint}
                        onVer={this.handleVer}
                        onEditar={this.handleEdit}
                        onAnular={this.handleAnular}
                        onImprimir={this.handleImprimir}
                        onChange={this._handleChangePagination}
                        onRechazar={this.handleRechazar}
                        onAprobar={this.handleAprobar}
                    /> :
                    <DetalleIngreso
                        pagination={this.state.pagination}
                        loadingExcel={this.state.loadingExcel}
                        loadingPdf={this.state.loadingPdf}
                        onExportExcel={this.handleDetalleExportExcel}
                        onChange={this._handleChangePagination}
                    />
                }

                <FormModal
                    visible={this.state.visible}
                    formValues={this.state.formValues}
                    onBuscarProveedor={this.handleBuscarProveedor}
                    onChangeProveedor={this.handleOnChangeProveedor}
                    onAgregarDetalle={this.handleAgregarDetalle}
                    onImportarRequerimiento={this.handleImportarRequerimiento}
                    onRemoverProducto={this.handleRemoverProducto}
                    onRemoverReferencia={this.handleRemoverReferencia}
                    onChangeTab={this.handleChangeTab}
                    onChange={this.handleChangeForm}
                    onBlur={this.handleChangeForm}
                    onClose={() => this.setState({ visible: false })}
                    onSave={this.handleSave}
                    onChangeNameProduct={this.handleChangeNameProduct}
                />
                <BuscarProductoModal
                    visible={this.state.productoVisible}
                    formValues={this.state.productoModal}
                    onChange={this.handleChangeProductoModal}
                    onChangeRow={this.handleChangeSelectedRowKey}
                    onCancel={() => this.setState({ productoVisible: false })}
                />
                <ImportarRequerimientoModal
                    visible={this.state.importarRequerimientoVisible}
                    formValues={this.state.importarRequerimientoModal}
                    onChangeRequerimientoModal={this.handleChangeRequerimientoModal}
                    onChangeRow={this.handleSelectedRowRequerimientoPorImportar}
                    onCancel={() => this.setState({ importarRequerimientoVisible: false })}
                    onHandleOkImportarRequerimiento={this.handleOkImportarRequerimiento}
                />
                <FormModalVer
                    visible={this.state.visibleVer}
                    formValues={this.state.formValues}
                    onChangeTab={this.handleChangeTab}
                    onClose={() => this.setState({ visibleVer: false })}
                />
                <RenombrarProductoModal
                    visible={this.state.renombrarProductoVisible}
                    formValues={this.state.renombrarProductoModal}
                    onCancel={() => this.setState({ renombrarProductoVisible: false })}
                    onSaveRename={this.handleOkChangeNameProduct}
                />
                <ImprimirModal
                    visible={this.state.imprimirVisible}
                    formValues={this.state.imprimirFormValues}
                    onChange={this.handleChangeImprimir}
                    onClose={() => this.setState({ imprimirVisible: false })}
                />

                <IngresoObservacionModal
                    visible={this.state.observacionVisible}
                    formValues={this.state.formValues}
                    onClose={() => this.setState({ observacionVisible: false })}
                    onSave={this.handleCompletarRechazo}
                />
            </div>
        )
    }

}